import {
	GET_WORK_CENTER_BY_ID,
	GET_WORK_CENTER_BY_ID_ERROR,
	GET_WORK_CENTER_BY_ID_SUCCESS,
} from '../../../constants';

export const getWorkCenterByIdReducer = (state, actions) => {
	switch (actions.type) {
		case GET_WORK_CENTER_BY_ID:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case GET_WORK_CENTER_BY_ID_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case GET_WORK_CENTER_BY_ID_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				workCenter: actions.payload,
			};
		default:
			return state;
	}
};
